export const STAT_LOCALE_OVERRIDE_STORAGE_KEY = 'statLocaleOverride';
/**
 * Returns the locale requested by the legacy STAT screenshot service. The value is intentionally
 * read-only in Sites: the service owns its lifecycle and Sites only honors it within study routes.
 */
export const getStatLocaleOverride = () => {
    try {
        return window.localStorage.getItem(STAT_LOCALE_OVERRIDE_STORAGE_KEY);
    }
    catch {
        return null;
    }
};
